export default __webpack_public_path__ + "static/media/game.ba630014.svg";